<div *ngIf="agriAvailable" class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> তফসিল-৩ </strong> <br>
            (কৃষি হইতে আয় থাকিলে নিম্নোক্ত তফসিলটি পূরণ করিতে হইবে)

        </div>
    </div>
    <div class="row mt-4 ml-3">
        <div class="col-2">কৃষিকাজের ধরণ:</div>
        <div class="col-10">
            {{returnData?.headSummery?.agricultureSummery?.agricultureTypes.join(', ')}}
        </div>            
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="10%">ক্রমিক <br> নং </td>
                        <td width="60%">আয়ের সারসংক্ষেপ </td>
                        <td width="30%">টাকার পরিমাণ </td>
                    </tr>
                    <tr>
                        <td width="10%">১।</td>
                        <td width="60%">বিক্রয়/ টার্নওভার/ প্রাপ্তি </td>
                        <td width="30%">{{data?.sales | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">২।</td>
                        <td width="60%">গ্রস মুনাফা</td>
                        <td width="30%">{{data?.netProfit | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৩।</td>
                        <td width="60%">সাধারণ ব্যায়, বিক্রয়জনিত ব্যায়, ভূমি উন্নয়ন কর, খাজনা, ঋণের সুদ, বিমা প্রিমিয়াম
                            এবং অন্যান্য ব্যায়সমূহ</td>
                        <td width="30%">{{data?.cost | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৪।</td>
                        <td width="60%">নিট আয় (ক্রমিক ০২ হইতে ক্রমিক ০৩ এর বিয়োগফল) </td>
                        <td width="30%">{{result | formatNumberReturnView}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>